import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const LockIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--lock')}
    viewBox="0 0 15.71 22.51"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <rect
      x="0.5"
      y="8.18"
      width="14.71"
      height="13.83"
      rx="2"
      ry="2"
      fill="none"
      stroke="#17171d"
      strokeMiterlimit="10"
    />
    <line
      x1="7.81"
      y1="12.83"
      x2="7.81"
      y2="17.5"
      fill="none"
      stroke="#17171d"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      fill="none"
      stroke="#17171d"
      strokeMiterlimit="10"
      d="
        M3.58,8.42
        V4.58
        A4.1,4.1,0,0,1,8,.74
        a4.11,4.11,0,0,1,4.42,3.84
        V8.42
      "
      transform="translate(-0.19 -0.24)"
    />
  </svg>
);

export default LockIcon;
